import animations from './animations';
import borderWidths from './borderWidths';
import colors from './colors';
import durations from './durations';
import easings from './easings';
import fonts from './fonts';
import fontSizes from './fontSizes';
import fontWeights from './fontWeights';
import radii from './radii';
import sizes from './sizes';
import spacing from './spacing';
import zIndex from './zIndex';

const tokens = {
  animations,
  borderWidths,
  colors,
  durations,
  easings,
  fonts,
  fontSizes,
  fontWeights,
  radii,
  sizes,
  spacing,
  zIndex,
};

export default tokens;
